import BreadCrumbComponent from "Components/common/breadcrumb";
import Button from "Components/common/Button";
import { observer } from "mobx-react";
import AddContact from "Pages/Dashboard/contacts/AddContact";
import React from "react";
import userDetail from "Stores/userDetail";

export const HeaderLayout = observer(props => {
  const {
    redirectUrl = "",
    breadcrumbArr = [],
    className = "",
    btnType = "",
    pageType = "",
    addContactBtn = false,
    callbackAction = () => {},
    hideLearnMore = false,
    // Optional content rendered inline after the breadcrumb (e.g. the
    // Accounts list dropdown, mirroring the Contacts header pattern).
    leftChildren = "",
    // Optional content rendered in the right-side action area, after
    // KnowMoreButton/btnType/addContactBtn (e.g. the Accounts "Add account"
    // button, mirroring where Contacts' Add Contacts button sits).
    rightChildren = ""
  } = props || {};

  const { userFeatureFlag = {}, userInfo = {} } = userDetail || {};
  const { noOfContactsEligible = 0, noOfContactsUsed = 0 } =
    userFeatureFlag || {};

  const remainingContactCount = () => {
    return noOfContactsEligible - noOfContactsUsed;
  };

  const buttonActionList = {
    calls: {
      id: "makeCallBtn",
      name: "makeCallBtn",
      btnText: "Make a Call",
      className: "makeCallBtn",
      loader: false,
      type: "button",
      click: callbackAction
    }
  };

  return (
    <section className="headerSection">
      <span className="wrapFlex">
        {(breadcrumbArr?.length && (
          <BreadCrumbComponent breadCrumbValue={breadcrumbArr} />
        )) ||
          ""}
        {leftChildren}
      </span>
      <div className={`add-new-dropdown ${className}PageHeader`}>
        {/* {redirectUrl && !hideLearnMore && (
          <KnowMoreButton redirectUrl={redirectUrl} />
        )} */}
        {btnType && <Button {...buttonActionList[btnType]} />}
        {addContactBtn && (
          <AddContact
            validContactUpload={remainingContactCount()}
            checkEligibleContactCount={remainingContactCount()}
            pageType
            isFromScheduleSeq={false}
          />
        )}
        {rightChildren}
      </div>
    </section>
  );
});

export default HeaderLayout;
